import { z } from 'zod';

export const userStickerScheme = z.object({
  Id: z.number(),
  StickerUrl: z.string().url(),
});

export const userStickersResponseSchema = z.object({
  StickerLimit: z.number().default(30),
  Stickers: userStickerScheme.array(),
});

export type UserSticker = z.infer<typeof userStickerScheme>;
export type UserStickersResponse = z.infer<typeof userStickersResponseSchema>;
